import { faFlag, faRoute } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChallengesCard, RoomType } from '@tryhackme/thm-ui-components';
import { useSavedRooms } from 'src/common/hooks';
import { useGetUserQuery } from 'src/common/slices';
import type { ChallengeRoomData, PovTagFilterOptions } from 'src/features/hacktivities/challenges/challenges.types';
import { StyledContainer, StyledSubtitle, StyledTitle } from '../reprofiling-shared.styles';
import { StyledCardWrapper } from './next-mission.styles';
export const ReprofilingNextMission = ({
  suggestedRoom,
  onLaunch
}: {
  suggestedRoom: ChallengeRoomData | undefined;
  onLaunch?: React.MouseEventHandler<HTMLAnchorElement>;
}) => {
  const {
    isSuccess: isAuth
  } = useGetUserQuery();
  const {
    savedRooms,
    loadingRoomCode,
    handleSavedRoom
  } = useSavedRooms({
    isAuth
  });
  if (!suggestedRoom) return null;
  const povTag = (suggestedRoom.tagDocs?.find(tagDoc => tagDoc.category === 'PoV')?.tag?.toLowerCase() ?? undefined) as PovTagFilterOptions | undefined;
  const technologies = suggestedRoom.tagDocs?.filter(tagDoc => tagDoc.category === 'Technology').map(tagDoc => tagDoc.tag);
  const icon = suggestedRoom.roomType === RoomType.Challenge ? faFlag : faRoute;
  return <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="ReprofilingNextMission" data-sentry-source-file="next-mission.tsx">
      <div>
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="next-mission.tsx">Ready To Launch Your Next Security Mission?</StyledTitle>
        <StyledSubtitle data-sentry-element="StyledSubtitle" data-sentry-source-file="next-mission.tsx">We've picked training tailored to your current skill level.</StyledSubtitle>
      </div>
      <StyledCardWrapper data-sentry-element="StyledCardWrapper" data-sentry-source-file="next-mission.tsx">
        <h3 data-type="room-title">
          <FontAwesomeIcon icon={icon} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="next-mission.tsx" /> {suggestedRoom.roomType}
        </h3>

        <ChallengesCard title={suggestedRoom.title} description={suggestedRoom.description} image={suggestedRoom.imageURL} progress={0} url={`/room/${suggestedRoom.code}?auto-join=true`} difficulty={suggestedRoom.difficulty} pageReferrer="reprofile-modal" roomType={suggestedRoom.roomType === 'challenge' ? RoomType.Challenge : RoomType.Walkthrough} povTag={povTag} tagsDoc={technologies} duration={suggestedRoom.timeToComplete ? `${suggestedRoom.timeToComplete} mins` : ''} handleSavedRoom={() => handleSavedRoom(suggestedRoom.code)} isLoading={loadingRoomCode === suggestedRoom.code} isRoomSaved={savedRooms.includes(suggestedRoom.code)} isUserAuth={isAuth} onClick={onLaunch} data-sentry-element="ChallengesCard" data-sentry-source-file="next-mission.tsx" />
      </StyledCardWrapper>
    </StyledContainer>;
};